var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-424 226 110 110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-334.8 271.5c-.3.1-.6.2-.8.2h-5.1v36.7c0 1.1-.9 2-2 2h-52.6c-1.1 0-2-.9-2-2v-36.7h-4.9c-1.1 0-2-.9-2-2 0-.3.1-.6.2-.8l7.5-16.3c.3-.7 1.1-1.2 1.8-1.2h51.7c.8 0 1.5.5 1.8 1.2l7.5 16.3c.3 1-.1 2.2-1.1 2.6zm-58.4 34.8h26.2v-23.7c0-1.1.9-2 2-2h13.3c1.1 0 2 .9 2 2v23.7h4.6v-34.6h-48.2v34.6h.1zm4.9-23.7c0-1.1.9-2 2-2h13.3c1.1 0 2 .9 2 2v13.3c0 1.1-.9 2-2 2h-13.3c-1.1 0-2-.9-2-2v-13.3z",
    fill: "#fff"
  })));
}

export default SvgStore;